<script setup>
import { onMounted } from "vue";
onMounted(() => {
  require("@/assets/js/hra.js");
});
</script>
<template>
  <main class="seo-calculators nav-seo npm-seo hra-seo">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a>
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>HRA Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->
    <div class="container">
      <h1 class="page-heading">HRA Calculator</h1>
      <h2 class="page-sub-heading">Calculate your HRA exemption.</h2>
      <div class="container no-padding-web">
        <div class="row">
          <div class="col-md-6 no-padding">
            <div class="slider-container">
              <form name="calculator">
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Salary (Basic p.a)</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="basicSalary"
                        value="600000"
                        min="10000"
                        max="2500000"
                        step="10"
                        id="basic-salary-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="600000"
                    min="10000"
                    max="2500000"
                    step="10"
                    id="basic-salary-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />

                  <div class="slider__row">
                    <div class="slider__min">₹10,000</div>
                    <div class="slider__max">₹25,00,000</div>
                  </div>
                </div>
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Dearness allowance(p.a)</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="da"
                        value="30000"
                        min="10000"
                        max="1000000"
                        step="10"
                        id="dearness-allowance-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="30000"
                    min="10000"
                    max="1000000"
                    step="10"
                    id="dearness-allowance-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />

                  <div class="slider__row">
                    <div class="slider__min">₹10,000</div>
                    <div class="slider__max">₹25,00,000</div>
                  </div>
                </div>
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">HRA received(p.a)</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="hra"
                        value="350000"
                        min="10000"
                        max="2500000"
                        step="10"
                        id="hra-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="350000"
                    min="10000"
                    max="2500000"
                    step="10"
                    id="hra-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />

                  <div class="slider__row">
                    <div class="slider__min">₹10,000</div>
                    <div class="slider__max">₹25,00,000</div>
                  </div>
                </div>
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Total rent paid(p.a)</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="rentPaid"
                        value="30000"
                        min="10000"
                        max="2500000"
                        step="10"
                        id="rent-paid-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="30000"
                    min="10000"
                    max="2500000"
                    step="10"
                    id="rent-paid-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />

                  <div class="slider__row">
                    <div class="slider__min">₹10,000</div>
                    <div class="slider__max">₹25,00,000</div>
                  </div>
                </div>

                <div class="selection nvp-sec">
                  <h3 class="slider__heading fw-600">Working In Metro City?</h3>
                  <div class="selection">
                    <label class="radio-button"
                      >Yes
                      <input
                        type="radio"
                        checked=""
                        name="metro-city"
                        value="1"
                      />
                      <span class="checkmark"></span>
                    </label>

                    <label class="radio-button"
                      >No
                      <input type="radio" name="metro-city" value="0" />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="col-md-6 no-padding" id="fix-cash">
            <div id="test"></div>
            <aside class="calculator-output nps-sidebar">
              <h3 class="calculator-output__heading">Exempted HRA</h3>
              <div id="exempted-hra" class="calculator-output__amount--large">
                ₹ 0
              </div>
              <h3 class="calculator-output__heading">Taxable HRA</h3>
              <div id="taxable-hra" class="calculator-output__amount--large">
                ₹ 3,50,000
              </div>
              <a href="https://wa.me/+917092362098" class="cta"
                >Invest Now</a
              >
            </aside>
          </div>
        </div>
      </div>
    </div>

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>What is HRA?</h2>
      <p></p>
      <p>
        The salary generally constitutes basic pay, allowances for travel,
        accommodation &amp; health as well as a forced saving in the form of
        gratuity or PF. House Rent Allowance (HRA) is that part of the salary
        that is provided by the employer for the expense towards accommodation
        rentals. It reduces the tax amount owed to the Government of India, as
        per Section 10 (13A) with Rule 2A of the Income Tax Act, 1961. It can be
        claimed only in the event that the employee or taxpayer lives in a
        rented accommodation.
      </p>
      <p></p>
      <h2>How is HRA calculated?</h2>
      <p></p>
      <p>
        Every public and private sector employee’s salary is broken down and
        detailed into various allowance, forced savings and the basic salary.
        The HRA is a part of this structure. Whether the employer has provided a
        separate amount for HRA or not, the HRA exemption can be calculated, so
        one can apply for the exemption during filing of ITR. To calculate HRA,
        as per the Income Tax Act, it is the lowest amount of all the following.
      </p>
      <p>
        1. The amount of HRA mentioned in the salary break up<br />
        2. 50% of the salary, if the employee is based in an Indian metro
        city<br />
        3. 40% of the salary, if the employee is based in an Indian non-metro
        city<br />
        4. Actual rent – 10% of salary (basic salary + commissions + dearness
        allowance)
      </p>
      <p></p>
      <h2>What is the HRA calculation formula?</h2>
      <p></p>
      <p>
        HRA calculation can be done by simply using the Upstox HRA calculator
        for Income Tax. The HRA Exemption is calculated to be the lowest of the
        following four values:
      </p>
      <p>
        1. The amount of HRA mentioned in the salary break up<br />
        2. 50% of the salary, if the employee is based in an Indian metro
        city<br />
        3. 40% of the salary, if the employee is based in an Indian non-metro
        city<br />
        4. Actual rent – 10% of salary (basic salary + commissions + dearness
        allowance)
      </p>
      <p>
        Let’s say the Basic Salary of an employee is Rs. 5,00,000 p.a. &amp; HRA
        provided by employer is Rs. 1,50,000. He pays rent of Rs. 2,50,000. Also
        let us assume that the employee is working out of New Delhi.
      </p>
      <p>
        1. HRA is Rs. 1,50,000<br />
        2. 50% of Salary is Rs. 2,50,000<br />
        3. Actual rent (2,50,000) – 10% of salary (50,000) is Rs. 2,00,000
      </p>
      <p>
        Hence, in the above mentioned scenario, the HRA Exemption, being the
        lowest of the three amounts is Rs. 1,50,000.
      </p>
      <p></p>
      <h2>How to Claim HRA Benefit?</h2>
      <p></p>
      <p>
        During filing Income Tax Returns, HRA Exemption can be claimed by
        providing yours and landlord’s PAN card copy, rent payment receipts and
        rental agreement/s. These documents must be submitted &amp; the employee
        may deduct from his Income Tax the lowest of the following amounts, as
        per the Income Tax Act, 1961. HRA Exemption is the lowest value amongst:
      </p>
      <p>
        1. The amount of HRA mentioned in the salary break up<br />
        2. 50% of the salary, if the employee is based in an Indian metro
        city<br />
        3. 40% of the salary, if the employee is based in an Indian non-metro
        city<br />
        4. Actual rent – 10% of salary (basic salary + commissions + dearness
        allowance)
      </p>
      <p></p>
      <h2>What is HRA Exemption?</h2>
      <p></p>
      <p>
        <span style="font-weight: 400"
          >HRA Exemption is a tax benefit that can be claimed by any employee of
          both the private &amp; public sector as long as they live in a rented
          property where they pay rent to the homeowner. Every employee is
          eligible to benefit from HRA Exemption as per their salary breakup.
          The lowest amount between your Housing Rental Allowance provided by
          the employer, 10% less than your basic salary, 50% for metro city
          dwellers and 40% for non-metro dwellers is the HRA exemption you can
          claim during filing of your ITR. You can claim this even if your
          employer does not provide HRA. In the case both you and your spouse or
          other family members share rental accommodation, either all parties
          must have separate rent payment receipts or only one person can claim
          HRA.</span
        >
      </p>
      <p></p>
      <h2>Documents Required to Claim the HRA Exemption?</h2>
      <p></p>
      <p>The documents required for claiming HRA Exemption are:</p>
      <p>
        1. If your rent increases over Rs. 1,00,000 in one financial year, you
        will have to provide both yours and your landlord’s PAN card copy.<br />
        2. The rental receipts which should have the date, landlord’s name, your
        name, landlord’s PAN details, rented accommodation address, duration of
        stay &amp; a revenue stamp and signature of the landlord. For a year,
        atleast 4 receipts are required as the same one can be used for 3
        months.<br />
        3. Rental agreement.
      </p>
      <p></p>
      <h2>What are the conditions for claiming HRA Exemption?</h2>
      <p></p>
      <p>The conditions for claiming HRA Exemption are:</p>
      <p>
        1. As per Section 80, the exemption can only be claimed when you have a
        rental agreement and are paying rent to a house owner.<br />
        2. In the periods that rent is not paid, the HRA is not deductible.<br />
        3. If you change jobs, the HRA is calculated monthly. The same is true
        if you move from a metro city to a non-metro city or vice versa.<br />
        4. Rent paid to any member of the family other than your father can be
        claimed under HRA. But, to claim this HRA, there must be regular monthly
        payments of the rent through bank transfers.
      </p>
      <p></p>
      <h2>What are the eligibility factors to avail HRA Exemptions?</h2>
      <p></p>
      <p>To be eligible to avail HRA Exemption, you must be:</p>
      <p>
        1. An employee in the private or public sector<br />
        2. Live in a rented accommodation close to your place of work<br />
        3. Paying rent to a house owner, with proof of an agreement &amp;
        receipts.
      </p>
      <p></p>
      <h2>
        What are the benefits of the HRA Exemption calculator with Upstox?
      </h2>
      <p></p>
      <p>
        The Upstox HRA Exemption calculator is an easy to use calculator that
        provides accurate answers instantaneously and cancels out human error.
        To quickly calculate your Housing Rental Allowance Exemption for Income
        Tax benefits, use this calculator. It is easy to understand and takes
        into account all parameters of HRA calculation, hence, providing the
        quickest accurate result.
      </p>
      <p><strong>HRA calculation examples:</strong></p>
      <p>
        Let’s say the Basic Salary of an employee is Rs. 7,00,000 p.a. &amp; HRA
        provided by employer is Rs. 4,50,000. He pays rent of Rs. 3,50,000. Also
        let us assume that the employee is working out of Mumbai.
      </p>
      <p>
        1. HRA is Rs. 4,50,000<br />
        2. 50% of Salary is Rs. 3,50,000<br />
        3. Actual rent (3,50,000) – 10% of salary (70,000) is Rs. 2,80,000
      </p>
      <p>
        Hence, in the above mentioned scenario, the HRA Exemption, being the
        lowest of the three amounts is Rs. 2,80,000.
      </p>
      <p>
        In the same example, what if the employee was living in the small town
        of Shimla?
      </p>
      <p>
        4. HRA is Rs. 4,50,000<br />
        5. 40% of Salary is Rs. 3,15,000<br />
        6. Actual rent (3,50,000) – 10% of salary (70,000) is Rs. 2,80,000
      </p>
      <p>
        Hence, in the above mentioned scenario, the HRA Exemption, being the
        lowest of the three amounts is Rs. 2,80,000.
      </p>
      <p></p>
    </section>

    <!-- Calculator Faqs Section-->

    <section class="container calculator_help_section">
      <h2 class="fs-28 bold help_here">Frequently Asked Questions</h2>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse1">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How is exemption on HRA calculated?</span>
                </span>
              </h3>
            </div>
            <div id="collapse1" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Every public and private sector employee’s salary is broken
                  down and detailed into various allowance, forced savings and
                  the basic salary. The HRA is a part of this structure. Whether
                  the employer has provided a separate amount for HRA or not,
                  the HRA exemption can be calculated, so one can apply for the
                  exemption during filing of ITR. To calculate HRA, as per the
                  Income Tax Act, it is the lowest amount of all the following.
                </p>
                <p>
                  1. The amount of HRA mentioned in the salary break up<br />
                  2. 50% of the salary, if the employee is based in an Indian
                  metro city<br />
                  3. 40% of the salary, if the employee is based in an Indian
                  non-metro city<br />
                  4. Actual rent – 10% of salary (basic salary + commissions +
                  dearness allowance)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse2">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What percent of salary is HRA?</span>
                </span>
              </h3>
            </div>
            <div id="collapse2" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  The HRA must be 10% less than your basic salary. If you live
                  in a metro city, the HRA is calculated at 50% of your basic
                  salary or if you live in a non-metro city, it is calculated at
                  40% of your basic salary.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse3">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Is HRA included in basic salary?</span>
                </span>
              </h3>
            </div>
            <div id="collapse3" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  No, HRA is a part of the gross salary, which includes basic
                  salary, allowances for travel, rent and health as well as
                  commissions, dearness allowance and forced savings like PF and
                  gratuity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse4">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How much HRA is allowed?</span>
                </span>
              </h3>
            </div>
            <div id="collapse4" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  The HRA must be 10% less than your basic salary. If you live
                  in a metro city, the HRA allowed is 50% of your basic salary
                  or if you live in a non-metro city, it is 40% of your basic
                  salary.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse5">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Can I get income tax benefit on HRA?</span>
                </span>
              </h3>
            </div>
            <div id="collapse5" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Yes, once you make the HRA exemption calculation for Income
                  tax, you can claim the exemption while filing your ITR. It is
                  the lowest amount amongst:
                </p>
                <p>
                  1. The amount of HRA mentioned in the salary break up<br />
                  2. 50% of the salary, if the employee is based in an Indian
                  metro city<br />
                  3. 40% of the salary, if the employee is based in an Indian
                  non-metro city<br />
                  4. Actual rent – 10% of salary (basic salary + commissions +
                  dearness allowance)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse6">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >Can I get both HRA tax exemption and tax rebate on my home
                    loan?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse6" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Yes, you can claim HRA exemption and tax rebate on any home
                  loan you may have. The deductions you can file in ITR would
                  include:
                </p>
                <p>
                  1. HRA tax exemption<br />
                  2. Tax rebate on home loan<br />
                  3. Tax deduction on Home Loan Principal payment
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse7">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Can HRA exemption be claimed in ITR?</span>
                </span>
              </h3>
            </div>
            <div id="collapse7" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Yes, once you make the HRA exemption calculation for Income
                  tax, you can claim the exemption while filing your ITR. It is
                  the lowest amount amongst:
                </p>
                <p>
                  1. The amount of HRA mentioned in the salary break up<br />
                  2. 50% of the salary, if the employee is based in an Indian
                  metro city<br />
                  3. 40% of the salary, if the employee is based in an Indian
                  non-metro city<br />
                  4. Actual rent – 10% of salary (basic salary + commissions +
                  dearness allowance)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse8">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >Can I claim HRA for rent paid on behalf of parents?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse8" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  No, HRA cannot be claimed if the parents live separately in a
                  house rented in either of their names. The parents rent can be
                  claimed as long as they are staying in a house rented by the
                  owner to you, in your name.
                </p>
                <p>
                  In the case the parents own the house and the employee is
                  staying with them, he can get a rental contract made with them
                  and pay them rent, which can then be claimed under HRA
                  exemption.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse9">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What are the rules for HRA exemption?</span>
                </span>
              </h3>
            </div>
            <div id="collapse9" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>The rules for claiming HRA Exemption are:</p>
                <p>
                  1. As per Section 80, the exemption can only be claimed when
                  you have a rental agreement and are paying rent to a house
                  owner.<br />
                  2. In the periods that rent is not paid, the HRA is not
                  deductible.<br />
                  3. If you change jobs, the HRA is calculated monthly. The same
                  is true if you move from a metro city to a non-metro city or
                  vice versa.<br />
                  4. Rent paid to any member of the family other than your
                  father can be claimed under HRA. But, to claim this HRA, there
                  must be regular monthly payments of the rent through bank
                  transfers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse10">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Can HRA exemption be claimed for two houses?</span>
                </span>
              </h3>
            </div>
            <div id="collapse10" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  No, HRA can only be claimed for the rental accommodation that
                  the employee lives in currently and no other place.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button class="similar-btn btn-all">View all</button>
          <button class="similar-btn btn-less" style="display: none">
            View less
          </button>
        </div>
        <div class="smooth-wrap">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Brokerage Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Margin Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Mutual Fund Returns Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SIP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPV Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Future Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SWP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> ELSS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Option Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> PPF Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Annual Growth Rate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> National Savings Certificate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Sukanya Samriddhi Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Atal Pension Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Gratuity calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Simple Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Fixed Deposit Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> GST Calculator</a>
            </h3>
          </div>
        </div>
      </div>
    </section>

    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style scoped>
</style>
